import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Button, Header, Table } from "semantic-ui-react";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class EstimateControls extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    dimension: PropTypes.string.isRequired,
    showDetails: PropTypes.bool.isRequired,
    controlsEnabled: PropTypes.bool.isRequired,
    docked: PropTypes.bool.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    controlsEnabled: true,
    docked: false,
    copyKey: "project_wizard.estimate_panel"
  };

  // -- RENDER -- //

  render() {
    const {
      showDetails,
      docked,
      handleShowDetails,
      dimension,
      controlsEnabled,
      copyKey,
      copy,
      children
    } = this.props;

    return (
      <Table
        style={{ lineHeight: "1em" }}
        verticalAlign="middle"
        attached={showDetails || docked ? "top" : false}
        inverted
        unstackable
      >
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <Header as="h3" inverted>
                {!showDetails && `${copy(`dimensions.time.${dimension}`)} `}
                {copy(`${copyKey}.title`)}
              </Header>
            </Table.Cell>

            {children}

            {controlsEnabled && (
              <Table.Cell textAlign="right" width="1">
                <Button
                  onClick={handleShowDetails}
                  icon={showDetails ? "angle down" : "angle up"}
                  size="mini"
                  type="button"
                  inverted
                />
              </Table.Cell>
            )}
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(EstimateControls);
